import React, { useState, useRef, useEffect, useContext } from 'react'
import PropTypes from 'prop-types'
import { Form, Input } from 'antd'

const EditableContext = React.createContext(null)
const EditableRow = ({ index, ...props }) => {
	const [form] = Form.useForm()
	return (
		<Form form={form} component={false}>
			<EditableContext.Provider value={form}>
				<tr {...props} />
			</EditableContext.Provider>
		</Form>
	)
}

const EditableCell = ({
	title,
	editable,
	children,
	dataIndex,
	record,
	handleSave,
	data,
	...restProps
}) => {
	const [editing, setEditing] = useState(false)
	const inputRef = useRef(null)
	const form = useContext(EditableContext)
	const [cellContent, setCellContent] = useState(
		record ? record[dataIndex] : ''
	)

	useEffect(() => {
		if (editing) {
			inputRef.current.focus()
		}
	}, [editing, children])

	const toggleEdit = () => {
		setEditing(!editing)
		form.setFieldsValue({
			[dataIndex]: record[dataIndex],
		})
	}

	const save = async () => {
		try {
			const values = await form.validateFields()
			handleSave({
				...record,
				...values,
			})
			toggleEdit()
			setCellContent(values[dataIndex])
		} catch (error) {
			console.log('Save failed: ', error)
		}
	}

	let childNode = children
	if (editable) {
		childNode = editing ? (
			<Form.Item
				style={{
					margin: 0,
				}}
				name={dataIndex}
				rules={[
					{
						required: false,
						message: `${title} is required.`,
					},
				]}>
				<Input ref={inputRef} onPressEnter={save} onBlur={save} />
			</Form.Item>
		) : (
			<div
				className="editable-cell-value-wrap"
				style={{
					paddingRight: 24,
				}}>
				{cellContent}
			</div>
		)
	}

	return (
		<td onClick={editable ? toggleEdit : null} {...restProps}>
			{childNode}
		</td>
	)
}
EditableCell.propTypes = {
	title: PropTypes.string,
	editable: PropTypes.bool,
	children: PropTypes.node,
	dataIndex: PropTypes.string,
	record: PropTypes.object,
	handleSave: PropTypes.func,
	restProps: PropTypes.any,
	data: PropTypes.array,
}

EditableRow.propTypes = {
	index: PropTypes.number,
	props: PropTypes.any,
}

export { EditableRow, EditableCell }
